(function ($) {
  windowsHeaight();
  Slider();
  TextAnimation();
  ThemeActions();

  let currentHash = location.hash.replace("#", "");
  let activeTabs = $('.accordion-head[data-id="' + currentHash + '"]');

  if (activeTabs.length) {
    activeTabs.addClass("open");
    activeTabs.next().show();
  }

  $(".customize--button").on("click", function () {
    $(".Customize--Content").slideToggle();
  });

  $(window).on("hashchange", function (e) {
    let currentHash = location.hash.replace("#", "");
    let activeTabs = $('.accordion-head[data-id="' + currentHash + '"]');
    $(".accordion-head").removeClass("open");
    $(".accordion-body").hide();

    $("body, html").animate({scrollTop: 0});

    if (activeTabs.length) {
      activeTabs.addClass("open");
      activeTabs.next().show();
    }
  });

  $(document).on("click", ".ColorSwatch__Radio", function () {
    $(this)
      .parent()
      .parent()
      .parent()
      .find(".ProductItem__Price")
      .html($(this).data("price"));
    $(this)
      .parent()
      .parent()
      .parent()
      .find(".Price--compareAt")
      .html($(this).data("compare-price"));
  });

  var HeadingTabbers = $(".DropdownMenu_sub .Linklist__Item");
  HeadingTabbers.on("mouseenter", function () {
    var me = $(this),
      image_target = me.data("img"),
      link = me.data("link"),
      title = me.data("title");

    if (image_target != "w_417,h_257") {
      $(".DropdownImage__Right img").attr("href", link);
      $(".DropdownImage__Right img").attr("src", image_target);
      $(".DropdownImage__Right .Link").html("Shop " + title);
    }
  });

  $(".pt-nav-toggle").on("click", function (e) {
    e.preventDefault();

    $(".filter-group").slideToggle();
  });

  let FontPicker = $(".FontPicker");

  if (FontPicker.length) {
    FontPicker.on("change", function () {
      let value = $(this).val(),
        self = $(this).find('[value="' + value + '"]'),
        className = self.attr("class");

      $(".FontManifest").removeClass("font-lato");
      $(".FontManifest").removeClass("font-garamond");
      $(".FontManifest").removeClass("font-candles");
      $(".FontManifest").removeClass("font-engraved");
      $(".FontManifest").removeClass("font-scramento");
      $(".FontManifest").addClass(className);
    });
  }
})(jQuery);

function windowsHeaight() {
  $(".Section__Slider__Image .Description").css({
    "min-height": $(window).height(),
  });

  $(".Contact__Content").css({
    height: $(window).height(),
  });

  $(".Collection__inline_filter .filter-group h4").click(function () {
    $(".Collection__inline_filter .filter-group").removeClass("active");
    $(this).stop().animate();
    $(this).parent().addClass("active");
  });

  $(document).on("click", function (e) {
    if (
      $(e.target).is(".active") == false &&
      $(e.target).is(".Collection__inline_filter .filter-group h4") == false
    ) {
      $(".active").removeClass("active");
    }
  });

  $(".navstyle-list li a").on("click", function () {
    if (!$(this).parents().hasClass("open")) {
      $("li").removeClass("open");
    }
    $(this).parent().toggleClass("open");
  });

  $(document).on("click", function (e) {
    if (
      $(e.target).is(".open") == false &&
      $(e.target).is(".navstyle-list li a") == false
    ) {
      $(".open").removeClass("open");
    }
  });

  $(".tab-a").click(function () {
    $(".tab").removeClass("tab-active");
    $(".tab[data-id='" + $(this).attr("data-id") + "']").addClass("tab-active");
    $(".tab-a").removeClass("active-a");
    $(this).parent().find(".tab-a").addClass("active-a");
  });

  $(".accordion").each(function () {
    var $accordian = $(this);
    $accordian.find(".accordion-head").on("click", function () {
      $(this).parent().find(".accordion-head").removeClass("open close");
      $(this).removeClass("open").addClass("close");
      $accordian.find(".accordion-body").slideUp();
      if (!$(this).next().is(":visible")) {
        $(this).removeClass("close").addClass("open");
        $(this).next().slideDown();
      }
    });
  });

  $(".DropdownMenu_sub .Linklist__Item").on("mouseover", function () {
    $(".DropdownImage__Right").parent().find("show").removeClass("show");
    $(".DropdownImage__Right").addClass("show");
  });

  $(".Image__with__text__link").click(function () {
    $(".Image__with__text__form__wrapper").addClass("visible");
    $("body").css("overflow", "hidden");
    $(".PageOverlay").addClass("is-visible");
  });

  $(".Image__with__text__form__wrapper .form__close, .PageOverlay").click(
    function () {
      $(".Image__with__text__form__wrapper").removeClass("visible");
      $("body").css("overflow", "visible");
      $(".PageOverlay").removeClass("is-visible");
    }
  );

  $("html").on("click", function () {
    $(".DropdownImage__Right").removeClass("show");
  });

  $(document).ready(function () {
    var $gallery = $(".Slideshow__Carousel").flickity({
      prevNextButtons: false,
      pageDots: false,
    });

    var $previousButton = $(".button--previous").on("click", function () {
      $gallery.flickity("previous");
    });

    var $nextButton = $(".button--next").on("click", function () {
      $gallery.flickity("next");
    });
  });

  // Collection Filter

  $(document).on("click", ".Button_Nav_Toggle", function () {
    $(".filter-group__Wrapper").toggleClass("show");
    $(".filter-group").fadeIn();
    $(".PageOverlay").addClass("is-visible");
    $("html").addClass("no-scroll");
  });

  $(document).on(
    "click",
    ".Button_Nav_Toggle_Close, .filter-clear, .filter-group .collection-name, .PageOverlay",
    function () {
      $(".filter-group__Wrapper").removeClass("show");
      $(".PageOverlay").removeClass("is-visible");
      $("html").removeClass("no-scroll");
    }
  );

  // collection sort function

  $(document).on("click", ".CollectionToolbar__Item--sort-phone", function () {
    $(".collection-sort-popover").addClass("visibles");
    $(".PageOverlay").addClass("is-visible, sort_popupopen");
    $("html").addClass("no-scroll");
  });

  $(document).on(
    "click",
    ".collection-sort-popover .Popover__Close, .Popover__ValueList .Popover__Value",
    function () {
      $(".collection-sort-popover").removeClass("visibles");
      $(".PageOverlay").removeClass("is-visible, sort_popupopen");
      $("html").removeClass("no-scroll");
    }
  );

  $(document).on(
    "click",
    ".CollectionToolbar__Item--sort-desk, .Popover__ValueList Popover__Value",
    function () {
      $(".collection-sort-popover_desk").toggleClass("visible");
    }
  );

  // collection product layout  funtion

  $(document).on(
    "click",
    ".LayoutType__Count1, .LayoutType__Count2",
    function () {
      var isCount1 = $(this).hasClass("LayoutType__Count1");
      $(".LayoutType__Count1, .LayoutType__Count2").removeClass("is-active");
      $(this).addClass("is-active");

      $(".CollectionInner__Products .ProductList--grid .Grid__Cell")
        .toggleClass("1/1--phone", isCount1)
        .toggleClass("1/2--phone", !isCount1);
    }
  );

  // Collection filter navigation

  $(".Filter_Navigation__LinkWrapper").click(function () {
    $(".Filter_Navigation__Popup").toggleClass("show");
    $(".PageOverlay").addClass("is-visible");
    $("html").addClass("no-scroll");
  });

  $(".Filter_Navigation__PopupClose, .PageOverlay").click(function () {
    $(".Filter_Navigation__Popup").removeClass("show");
    $(".PageOverlay").removeClass("is-visible");
    $("html").removeClass("no-scroll");
  });

  $(".Filter_Navigation__LinkWrapperDesk").click(function () {
    $(".Filter_Navigation__PopupDesk").toggleClass("show");
  });

  // product description

  $(document).on("click", ".ProductMeta__readmore", function () {
    $(".ProductMeta__Details").addClass("is-visible");
    $(".PageOverlay").addClass("is-visible");
    $(".Product__Info").addClass("popup_details_open");
  });

  $(document).on(
    "click",
    ".ProductMeta__DetailsClose, .PageOverlay",
    function () {
      $(".ProductMeta__Details").removeClass("is-visible");
      $(".PageOverlay").removeClass("is-visible");
      $(".Product__Info").removeClass("popup_details_open");
    }
  );

  // metal and size

  $(document).on("click", ".ProductForm__VariantsOpen", function () {
    $(".ProductForm__Variants").addClass("is-visible");
    $(".PageOverlay").addClass("is-visible");
    $(".Product__Info").addClass("popup_details_open");
  });

  $(document).on("click", ".ProductForm__DetailsClose", function () {
    $(".ProductForm__Variants").removeClass("is-visible");
    $(".PageOverlay").removeClass("is-visible");
    $(".Product__Info").removeClass("popup_details_open");
  });
}

function Slider() {
  var $status = $(".paginationNumber");
  var $slickElement = $(".Slider__Images");

  $slickElement.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + " | " + slick.slideCount);
    }
  );

  $slickElement.slick({
    dots: false,
    centerMode: true,
    arrows: true,
    prevArrow: $(".prev"),
    nextArrow: $(".next"),
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".Article__Images__Slider").slick({
    dots: false,
    arrows: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".Image__with__text__Image__slider").slick({
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: false,
    adaptiveHeight: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".gift-img_slider").slick({
    dots: true,
    arrows: false,
    adaptiveHeight: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  });

  // $(document).ready(function () {
  //   $(".filter-group-item .filter-group-head").click(function () {
  //     $(this).next(".scroll-content__wrapper").slideToggle();
  //     $(this).toggleClass("visible");
  //   });
  // });

  $(document).ready(function () {
    $(document).on(
      "click",
      ".CollectionInner__Sidebar .filter-group-item .filter-group-head",
      function () {
        $(this).next(".scroll-content__wrapper").slideToggle();
        $(this).toggleClass("visible");
      }
    );
  });

  $(".CollectionToolbar__HideFilter button").click(function () {
    $(".CollectionInner__Sidebar").toggleClass("hide");
    $(".CollectionInner__Products").toggleClass("wide");
  });

  $(".swatch-view-item").on("click", function () {
    const swatchValue = $(this).data("value");

    $('.ProductItem__ColorSwatchItem input[type="radio"]').each(function () {
      if ($(this).val() === swatchValue) {
        $(this).prop("checked", true).trigger("change");
      }
    });
  });
}

function TextAnimation() {
  AOS.init({
    duration: 1200,
    once: true,
  });
}

function ThemeActions() {
  document.addEventListener("DOMContentLoaded", function () {
    bindCollectionFormEvent();

    var endlessScroll = new Ajaxinate({
      method: "click",
      container: "#AjaxinateLoop",
      pagination: "#AjaxinatePagination",
      loadingText: "Loading.....",
      callback: bindCollectionFormEvent,
    });

    bindVariantClickEvent();
  });
}

function bindCollectionFormEvent() {
  $(document).on("submit", ".collection-form", function (e) {
    e.preventDefault();
    var data = $(this).serialize();
    addItemToCart(data);

    $(".cart-icon--bar")
      .click(function (e) {
        e.preventDefault();
        this.click();
      })
      .click();
  });
}

function bindVariantClickEvent() {
  $(document).on("click", ".variant-size", function () {
    var variantId = $(this).data("variant-id");
    var form = $(this).closest("form");

    form.find('input[name="id"]').val(variantId);
    form.submit();
  });
}

function addItemToCart(data) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
    },
  });
}

document.addEventListener("DOMContentLoaded", function () {
  function updatePricesAndPoints(variant) {
    // Re-query DOM elements
    var priceMainElement = document.querySelector(".ProductMeta__Price__main");
    var priceCompareElement = document.querySelector(".ProductMeta__Price__compare");
    var pointsElement = document.querySelector("[data-lion-points-for-product-id]");

    // Get the active currency symbol
    const currencySymbols = {
      GBP: "£",
      EUR: "€",
      USD: "$",
      AUD: "A$",
      CAD: "C$",
      JPY: "¥",
    };
    const activeCurrency = Shopify?.currency?.active || "GBP"; // Default to GBP if not available
    const currencySymbol = currencySymbols[activeCurrency] || activeCurrency; // Fallback to activeCurrency if no symbol found

    // Clear existing prices
    if (priceMainElement) {
      priceMainElement.innerHTML = "";
      priceMainElement.style.display = "none";
    }
    if (priceCompareElement) {
      priceCompareElement.innerHTML = "";
      priceCompareElement.style.display = "none";
    }

    // Update with new variant prices
    if (variant) {
      if (priceMainElement && variant.price) {
        // Add the currency symbol explicitly
        priceMainElement.innerHTML = `<span data-money-convertible>${currencySymbol}${(variant.price / 100).toFixed(2)}</span>`;
        priceMainElement.style.display = "inline-block";
      }

      if (priceCompareElement && variant.compare_at_price && variant.compare_at_price > variant.price) {
        // Add the currency symbol explicitly for compare-at price
        priceCompareElement.innerHTML = `<span data-money-convertible>${currencySymbol}${(variant.compare_at_price / 100).toFixed(2)}</span>`;
        priceCompareElement.style.display = "inline-block";
      }

      // Update Rewards Points
      if (pointsElement) {
        const points = Math.floor(variant.price / 100); // Example calculation: 10% of price
        pointsElement.innerHTML = points;
        pointsElement.setAttribute("data-lion-points-for-product-id", variant.id);
      }
    }
  }

  // Shopify's variant change event
  document.addEventListener("variant:changed", function (event) {
    const variant = event.detail.variant; // Shopify passes the variant object
    updatePricesAndPoints(variant);
  });

  // Initial run for default variant
  const defaultVariantElement = document.querySelector('[data-default-variant]');
  if (defaultVariantElement) {
    const defaultVariant = JSON.parse(defaultVariantElement.textContent);
    updatePricesAndPoints(defaultVariant);
  }
});






